import { useRouter } from 'next/router'
import Link from 'next/link'
import tw, { styled, theme } from 'twin.macro'

const StyledPostTypeRow = styled.div`
  padding: 10px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 8px;
  position: sticky;
  top: 60px;
  background-color: white;
  z-index: 10;

  ${tw` md:p-0`};

  @media (min-width: ${theme`screens.md`}) {
    max-width: 720px;
    margin: 0 auto;
    top: 80px;
    padding-bottom: 16px;
  }
  @media (min-width: ${theme`screens.lg`}) {
    max-width: 960px;
    margin: 0 auto;
    top: 80px;
    padding-bottom: 16px;
  }
`

const StyledPostTypeButton = styled.button<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? '#fff' : '#333')};
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  background-color: ${({ isActive }) => (isActive ? '#7d7af4' : '#f7f7f7')};
`

export const HideBarClass = ['trend', 'diary', 'entertainment', 'sport']

const PostTypeBar = () => {
  const { query } = useRouter()
  let postTypes = Array.isArray(query.postTypes) ? query.postTypes : query.postTypes?.split(',')
  if (!postTypes || postTypes.length === 0) postTypes = ['web']
  const activeTab = postTypes.length == 2 ? 'all' : postTypes[0]
  const basePath = query.clas ? `/explore/${query.clas}` : '/'

  if (HideBarClass.includes(query.clas as string)) {
    return null
  }

  const getSearchParams = (newPostTypes?: string) => {
    const params = new URLSearchParams(
      Object.entries(query)
        .filter(([key]) => key !== 'clas')
        .filter(([, value]) => value !== undefined)
        .map(([key, value]) => [key, value.toString()]),
    )
    if (newPostTypes) {
      params.set('postTypes', newPostTypes)
    }
    return params.toString()
  }

  return (
    <StyledPostTypeRow>
      <a href={`${basePath}`}>
        <StyledPostTypeButton isActive={activeTab === 'web'}>編輯精選</StyledPostTypeButton>
      </a>
      <a href={`${basePath}?${getSearchParams('user')}`}>
        <StyledPostTypeButton isActive={activeTab === 'user'}>創作者精選</StyledPostTypeButton>
      </a>
      <a href={`${basePath}?${getSearchParams('web,user')}`}>
        <StyledPostTypeButton isActive={activeTab === 'all'}>全部文章</StyledPostTypeButton>
      </a>
    </StyledPostTypeRow>
  )
}

export default PostTypeBar
